// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Overlay__overlay--sA81s"};